{
    "Auth0": {
        "Domain": "auth.dev2.liquiditycube.net",
        "ClientId": "FmSPiybU6pZyhNJhj18LDadmVEQrhFuX",
        "Audience": "https://dev.liquiditycube.net/api",
        "Namespace": "https://liquiditycube.net"
    },
    "BaseUrl": "https://api.dev2.liquiditycube.net",
    "BannerUrl": "DEV",
    "MegaPipe": {
        "BaseUrl": "https://megapipe.dev2.liquiditycube.net"
    }
}